
export default {
    name: 'rapport-recette',
    components: {},
    props: {
        rapport_recettes: Array,
        by_prestation: String,
        modal_toggler: Number
    },
    data () {
        return {
            fields: [
                { key: 'no', label: 'N°' },
                { key: 'ref', label: 'Référence' }, "date", { key: 'user', label: 'Caissier(e)' },
                { key: 'libelle', label: 'Libellé' }, "patient", { key: 'qte', label: 'Qté' }, { key: 'pu', label: 'P.U' },  
                { key: 'total', label: 'Total' }, { key: 'coupon', label: 'Remise' }, { key: 'ba', label: 'BA*' },
                { key: 'tba', label: 'TBA*' }, { key: 'taux', label: 'Taux' }, 
                { key: 'montant_du', label: 'Mnt dû*' }, { key: 'entree', label: 'Entrées' }, 
                { key: 'reste_a_payer', label: 'Rst*' }, 'statut'
            ],
           
            filter: "",
            perPage: -1,
            print_per_page: -1,
            currentPage: 1,
            total_pages: 0,
            recette_len: 0,
        }
    },

    watch: {
        modal_toggler() {
            this.refreshRecette()
            this.filter = this.by_prestation
        }
    },

    computed: {

    },

    mounted () {
        
    },

    methods: {
        refreshRecette() {
            if (this.rapport_recettes) {
                this.recette_len = this.rapport_recettes.length
            }
        }
    }
}
